import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { EditProfile } from '@/features/cleaner/edit-profile';
import { HeaderDashboard } from '@/components/shared/header-dashboard';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/edit-profile'
)({
  component: EditProfilePage,
});

function EditProfilePage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/cleaner/view-profile' })}
        />
        <HeaderDashboard.Title>Edit profile</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <EditProfile />
      </div>
    </div>
  );
}
